export const translateActions = t => ({
  SHOW: t('rolesForm.show', 'Przeglądanie'),
  CREATE: t('rolesForm.create', 'Dodawanie'),
  EDIT: t('rolesForm.edit', 'Edytowanie'),
  REMOVE: t('rolesForm.remove', 'Usuwanie'),
  EXPORT: t('rolesForm.export', 'Export'),
  IMPORT: t('rolesForm.import', 'Import'),
  NOTE: t('rolesForm.note', 'Notatki'),
});
